import React, {useEffect} from "react"
import styles from './Visualisations.module.scss'
import {message, Select, Spin} from "antd"
import {QueryMetaData} from "../types/QueryMetaData";
import _ from "lodash";
import {QueryField} from "../types/Query";
import {IDENTIFIER_CHOICE, SUM_CHOICE} from "../../../components/query-builder/components/ValueDialog";
import {ChartType} from "./types/ChartType";
import {ReactComponent as ValuesIcon} from '../../../components/query-builder/icons/Values.svg'

export type ValueFieldsProps = {
    queryMetadata: QueryMetaData | undefined,
    selectedValue: QueryField | undefined,
    chartType: ChartType
    setSelectedValue: (queryField: QueryField | undefined) => void,
}

export const ValueFields = ({queryMetadata, selectedValue, chartType, setSelectedValue}: ValueFieldsProps) => {

    const toValue = (qf: QueryField | undefined) => {
        return qf ? `${qf.code}${qf.aggtype}` : undefined
    }

    const toQueryField = (value: string | undefined) => {
        if (queryMetadata) {
            return queryMetadata.query.values.find(valueField => toValue(valueField) === value)
        }
        return undefined
    }

    const options = queryMetadata ? queryMetadata.query.values.map((valueField) => {
        return {
            value: toValue(valueField),
            label: `${queryMetadata.fields[valueField.code].name} (${_.upperFirst(valueField.aggtype)})`,
            disabled: ChartType.BAR === chartType && IDENTIFIER_CHOICE.value !== valueField.aggtype && SUM_CHOICE.value !== valueField.aggtype,
            'data-testid': `${valueField.code}`,
        }
    }) : []

    useEffect(() => {
        if (ChartType.BAR === chartType) {
            const currentOption = options.find(i => i.value === toValue(selectedValue))
            if (currentOption && currentOption.disabled) {
                const firstEnabledOption = options.find(i => !i.disabled)
                if (firstEnabledOption) {
                    const valueField = toQueryField(firstEnabledOption.value)
                    message.warn(`Value has changed to ${firstEnabledOption.label}.`)
                    setSelectedValue(valueField)
                } else {
                    setSelectedValue(undefined)
                }

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartType, options])

    if (queryMetadata === undefined) {
        return <div className={styles['value-fields']}>
            <Spin/>
        </div>
    }

    return <div className={styles['value-fields']}>
        <ValuesIcon className={styles.fieldTypeIcon} />
        <span className={styles.fieldTypeLabel}>Values</span>
        <Select
            value={toValue(selectedValue)}
            defaultValue={toValue(queryMetadata.query.values[0])}
            onChange={(newValueCode) => {
                const valueField = toQueryField(newValueCode)
                setSelectedValue(valueField!)
            }}
            options={options}
            style={{ minWidth: "100px" }}
        />
    </div>
}